import script from "./ShowAbsence.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShowAbsence.vue?vue&type=script&lang=ts&setup=true"

import "./ShowAbsence.vue?vue&type=style&index=0&id=76569396&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76569396"]])

export default __exports__